import React from 'react';
import {Trans, withTranslation} from "react-i18next";

let LegalDisclaimerComponent = ({t}) => {
    return <div className="form-disclaimer">
        <p>
            <Trans i18nKey="form.disclaimer" t={t}
                   components={[<a href={t('footer.urls.privacy')} className="form-link">_</a>]}/>
        </p>
    </div>
};

export default withTranslation()(LegalDisclaimerComponent)